/** Loading is a two-pixel line under the bar. Nothing spins. */
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

export function Laadbalk() {
  const bezig = useIsFetching() + useIsMutating() > 0;

  return (
    <div className="relative h-[2px] shrink-0 overflow-hidden bg-line/60" aria-hidden="true">
      {bezig ? <div className="laadbalk-loper" /> : null}
    </div>
  );
}
